let news = null
export default {
    news
}